<template>
  <div class="select-dialog">
    <el-dialog
      :title="title"
      :visible="visible"
      :before-close="beforeCloseHandler"
      @close="closeHandler"
      @closed="closedHandler"
      width="1000px"
    >
      <div class="choose_c">
        <div class="tree_c wrapper">
          <div class="title_c">通信录</div>
          <div class="head_c">
            <div
              class="tab"
              @click="changeTab(selectTabs.Depart)"
              :class="[
                currentTab == selectTabs.Depart ? 'tab-active' : '',
                isTabDisabled(selectTabs.Depart) ? 'tab-disabled' : '',
              ]"
            >
              部门
            </div>
            <div
              class="tab"
              @click="changeTab(selectTabs.Group)"
              :class="[
                currentTab == selectTabs.Group ? 'tab-active' : '',
                isTabDisabled(selectTabs.Group) ? 'tab-disabled' : '',
              ]"
            >
              群组
            </div>
          </div>
          <div class="body_c">
            <el-tree
              v-if="currentTab == selectTabs.Depart"
              :load="loadNode"
              lazy
              :expand-on-click-node="false"
              @node-click="treeNodeClick"
              :props="treeProps"
            >
            </el-tree>
            <div v-if="currentTab == selectTabs.Group" class="group_c">
              <ul>
                <li
                  v-for="group in groupList"
                  :key="group.id"
                  class="el-tree-node group-item"
                >
                  <div
                    class="el-tree-node__content"
                    @click.stop="selectGroup(group)"
                    :class="[isGroupSelected(group) ? 'is-selected' : '']"
                  >
                    <span>{{ group.name }}</span>
                    <el-button type="text" @click.stop="addGroupToRight(group)" v-if="addGroupToRightDisabled == false">
                      添加
                      <i class="el-icon-d-arrow-right"></i>
                    </el-button>
                  </div>
                </li>
              </ul>
              <el-pagination
                @current-change="handleGroupCurrentChange"
                :current-page="groupCurrentPage"
                :page-size="groupPageSize"
                layout="total, prev, pager, next"
                :total="groupTotalCount"
              ></el-pagination>
            </div>
          </div>
        </div>
        <!-- 中间栏候选 -->
        <div class="candidate_c wrapper">
          <div class="title_c">{{ currentDepartmentName }}</div>
          <div class="head_c">
            <el-button type="text" @click="middleAllSelected" :disabled="canSelectAll == false" :data-a="canSelectAll">全选</el-button>
          </div>
          <div class="body_c">
            <!-- 这里要注意，depart list和 user list是两个不同的list，所以他们存在id相同的情况，在绑定key时要特殊处理 -->
            <ul>
              <li
                class="el-tree-node"
                v-for="dept in middleDepartList"
                :key="`depart_${dept.id}`"
              >
                <div class="el-tree-node__content">
                  <el-checkbox
                    :value="isDepartSelected(dept.id)"
                    @change="changeSelectDept(dept)"
                    :disabled="middleDepartSelectDisabled"
                    >{{ dept.name }}</el-checkbox
                  >
                </div>
              </li>
              <li
                class="el-tree-node"
                v-for="user in middleUserList"
                :key="`user_${user.id}`"
              >
                <div class="el-tree-node__content">
                  <el-checkbox
                    :value="isUserSelected(user.id)"
                    @change="changeSelectUser(user)"
                    :disabled="middleUserSelectDisabled"
                    >{{ user.displayName || user.name }}</el-checkbox
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 右边已经选择的列表 -->
        <div class="result_c wrapper">
          <div class="title_c">已选列表</div>
          <div class="head_c">
            <el-button type="text" icon="el-icon-delete" @click="removeAllRight"
              >移除全部</el-button
            >
          </div>
          <div class="body_c">
            <!-- 右边部分显示选定的部门群组或者个人 -->
            <ul>
              <li
                class="el-tree-node"
                v-for="depart in rightDepartList"
                :key="depart.id"
              >
                <div class="el-tree-node__content">
                  <i
                    class="el-icon-delete"
                    @click="removeRightDepart(depart)"
                  ></i>
                  <span>{{ depart.name }}</span>
                </div>
              </li>
            </ul>
            <ul>
              <li
                class="el-tree-node"
                v-for="group in rightGroupList"
                :key="group.id"
              >
                <div class="el-tree-node__content">
                  <i class="el-icon-delete" @click="removeRightGroup(group)"></i>
                  <span>{{ group.name }}</span>
                </div>
              </li>
            </ul>
            <ul>
              <li
                class="el-tree-node"
                v-for="user in rightUserList"
                :key="user.id"
              >
                <div class="el-tree-node__content">
                  <i class="el-icon-delete" @click="removeRightUser(user)"></i>
                  <span>{{ user.displayName || user.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="closeDialog" type="info">取 消</el-button>
        <el-button type="primary" @click="submitSelectedList">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectTabs, tabIndex } from "./variables";
import Constants from "@/utils/consts";
import { getSubUserService, getSubService } from "@/services/departService";
import { getDeptListService } from "@/services/sysSettingService";
import { groupDetailService, getGroupService } from "@/services/groupService"; // 获取群组列表和群组内人员列表
export default {
  name: "SelectDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      type: String,
      default: "选择",
    },
    departOn: {
      // 左侧部门的tab能不能点
      type: Boolean,
      default: true,
    },
    groupOn: {
      // 左侧的群组的tab能不能点
      type: Boolean,
      default: true,
    },
    canSelectDepart: {
      // 中间里能不能选部门
      type: Boolean,
      default: true,
    },
    canSelectUser: {
      // 中间里能不能选个人
      type: Boolean,
      default: true,
    },
    canSelectGroup: {
      // 是否左侧可以直接选择群组到右侧
      type: Boolean,
      default: true,
    },
    maxSelectedItem: { // 可同时选择最多几个"东西"，0表示无限制，
      type: Number,
      default: 0
    },
    dataKey: { // close时返回的数据会带上这个key，用来区分这个返回是给那个功能使用的。因为在一个页面里，可以有一个dialog，但是几个按钮都会调用这个dialog
      type: String,
      default: "default"
    },
    canSelectAll: {
      type: Boolean,
      default: true
    }


  },
  data() {
    return {
      treeProps: {
        label: "name",
      },
      selectTabs: selectTabs,
      selectedList: [],
      currentTab: selectTabs.Depart, // 左侧默认是部门
      currentDepartId: null, // 左侧选择的当前部门id【并不一定真的是部门id，有可能是根组织id】
      middleDepartList: [], // 中间用来备选的列表。部门
      middleUserList: [], // 人。这里的人可能是组织的人，也可能是群组的人，但都是员工，所以用一个就行
      rightDepartList: [], // 右侧选定的部门
      rightUserList: [], // 右侧选定的人
      rightGroupList:[], //  右侧选定的group
      groupTotalCount: 0,
      groupPageSize: 13,
      groupCurrentPage: 1,
      groupList: [], // 左侧group备选列表
      leftGroupSelected: null, //左侧选定的group，用来做选中状态的
    };
  },
  computed: {
    currentDepartmentName() {
      if (this.currentTab == selectTabs.Depart) {
        return "部门";
      }
      if (this.currentTab == selectTabs.Group) {
        return "群组";
      }
      return "";
    },

    middleDepartSelectDisabled() {
      // 中间候选项是否可以选择
      // 1.明确不可以选择部门，则返回true
      // 2.明确可以选择部门，但是又明确了选择的数量上限时，如果已经满了，则返回true
      // 3.其他情况都是false
      if (this.canSelectDepart == false) {
        return true;
      } 
      if (this.maxSelectedItem > 0) {
        return this.rightDepartList.length + this.rightUserList.length + this.rightGroupList.length >= this.maxSelectedItem;
      }
      return false;
    },
    middleUserSelectDisabled() {
      if (this.canSelectUser == false) {
        return true;
      } 
      if (this.maxSelectedItem > 0) {
        return this.rightUserList.length + this.rightDepartList.length + this.rightGroupList.length >= this.maxSelectedItem;
      }
      return false;
    },
    addGroupToRightDisabled() {
      if (this.canSelectGroup == false) {
        return true;
      }
      if (this.maxSelectedItem > 0) {
        return this.rightUserList.length + this.rightDepartList.length + this.rightGroupList.length >= this.maxSelectedItem;
      }
      return false;
    }
  },
  watch: {
    currentTab: function (newValue, oldValue) {
      // 切换到群组tab时重新获取一次数据
      if (newValue != oldValue && newValue == selectTabs.Group) {
        this.getGroupList();
      }
    },
  },
  methods: {
    //---------dialog 操作数据--------------

    addGroupToRight(group) {
      // 在左侧栏选择group，将group添加到“已选择”列表
      let list = this.rightGroupList;
      let index = list.findIndex((ele) => ele.id == group.id);
      if (index == -1) {
        list.push(group);
      }
      this.$set(this, "rightGroupList", list);
    },

    isGroupSelected(group) {
      if (!this.leftGroupSelected) {
        return false;
      }
      return this.leftGroupSelected.id == group.id;
    },

    handleGroupCurrentChange(page) {
      this.groupCurrentPage = page;
      this.getGroupList();
    },

    getGroupList() {
      let param = {
        orgId: sessionStorage.getItem("orgId"),
        pageSize: this.groupPageSize,
        pageIndex: this.groupCurrentPage,
      };
      getGroupService(param)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.groupList = res.data || [];
            this.groupTotalCount = res.total;
          } else if (res.code == Constants.Code_Err) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.error(Constants.Err_Msg);
          }
        })
        .catch((error) => {
          this.$message.error(Constants.Err_Msg);
        });
    },

    getGroupUserList() {
      groupDetailService({
        groupId: this.leftGroupSelected.id,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let data = res.data.userRelationList || [];
            // console.log('1111--', data);
            let list = data.map((item) => {
              return { ...item, id: item.userId, name: item.userName, displayName: item.userName };
            });
            this.middleUserList = list;
            // console.log('选定群组后，middle备选人员', this.middleUserList);
          } else if (res.code == Constants.Code_Err) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.error(Constants.Err_Msg);
          }
        })
        .catch((error) => this.$message.error(Constants.Err_Msg));
    },

    selectGroup(group) {
      console.log("点击左侧的group", group);
      if (this.leftGroupSelected != group) {
        this.leftGroupSelected = group;
        this.getGroupUserList();
      }
    },

    loadNode(node, resolve) {
      // 根级就应该是组织根级，“xxx集团”
      // 1级node就根据orgId获取组织下有哪些部门
      // 剩下的级别的node就根据部门id，一级一级的部门去获取下属的列表
      console.log("load node==", node.level, node);
      if (node.level == 0) {
        resolve([{id: sessionStorage.getItem('orgId'), name: sessionStorage.getItem('orgName'), isRootOrg: true}])
      }else if (node.level == 1) {
        let reqParam = {
          pid: 0,
          orgId: sessionStorage.getItem("orgId"),
        };
        getDeptListService(reqParam)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              let list = res.data || [];
              resolve(list);
              // console.log("获取根级组织的部门列表", list);
            } else if (res.code == Constants.Code_Err) {
              resolve([]);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              resolve([]);
              this.$message.error(Constants.Err_Msg);
            }
          })
          .catch((error) => {
            this.$message.error(Constants.Err_Msg);
            resolve([]);
          });
      } else {
        // 去获取各级的数据
        // console.log("getSubService ==", node.id);
        getSubService({ deptId: node.data.id })
          .then((res) => {
            // console.log("====res", res.data);
            if (res.code == Constants.Code_OK) {
              let list = res.data || [];
              resolve(list);
            } else if (res.code == Constants.Code_Err) {
              resolve([]);
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              resolve([]);
              this.$message.error(Constants.Err_Msg);
            }
          })
          .catch((error) => {
            this.$message.error(Constants.Err_Msg);
          });
      }
    },
    changeTab(tab) {
      if (this.isTabDisabled(tab)) {
        return;
      }
      if (tab != this.currentTab) {
        this.currentTab = tab;
      }
    },
    isTabDisabled(tab) {
      if (tab == selectTabs.Depart) {
        return !this.departOn;
      }
      if (tab == selectTabs.Group) {
        return !this.groupOn;
      }
    },
    isDepartSelected(depId) {
      // 判断此部门是否已经选择过，从而在checkbox显示正确的选择状态
      if (
        this.canSelectDepart == false ||
        !this.rightDepartList ||
        this.rightDepartList.length == 0
      ) {
        return false;
      }
      let index = this.rightDepartList.findIndex(
        (depart) => depart.id == depId
      );
      return index != -1;
    },
    isUserSelected(userId) {
      if (
        this.canSelectUser == false ||
        !this.rightUserList ||
        this.rightUserList.length == 0
      ) {
        return false;
      }
      let index = this.rightUserList.findIndex((item) => item.id == userId);
      return index != -1;
    },
    changeSelectDept(dept) {
      //  切换中间部门的选择。
      let list = this.rightDepartList;
      let index = list.findIndex((ele) => ele.id == dept.id);
      if (index >= 0) {
        list.splice(index, 1);
      } else {
        list.push(dept);
      }
      this.$set(this, "rightDepartList", list);
    },
    changeSelectUser(user) {
      let list = this.rightUserList;
      let index = list.findIndex((ele) => ele.id == user.id);
      if (index >= 0) {
        list.splice(index, 1);
      } else {
        list.push(user);
      }
      this.$set(this, "rightUserList", list);
      console.log('00', list);
    },
    middleAllSelected() {
      if(this.maxSelectedItem > 0 && this.rightDepartList.length + this.rightUserList.length + this.rightGroupList.length >= this.maxSelectedItem) {
        // 如果超过设定选择的上限了，就提示
        this.$message.warning('选择超过数量限制');
        return;
      }
      // 中间的候选栏点击了全选，如果是只选部门的就只选部门，如果是选人的就选人，如果都可以，那就部门和人都要选
      let candidateDepartList = [];
      let candidateUserList = [];
      if (this.canSelectDepart && this.middleDepartList && this.middleDepartList.length > 0) {
        this.middleDepartList.forEach((depart) => {
          // 这里做一层过滤。在点全选之前，可能已经单个的选择了某几个部门，右边已经有选定的了。这样别重复添加，虽然后台也会处理，但是前台重复了也是个bug
          // 其实rightXXXlist可以做个Set，这样add时就保证不会重复
          let index = this.rightDepartList.findIndex(
            (item) => item.id == depart.id
          );
          if (index == -1) {
            candidateDepartList.push(depart);
          }
        });
      }

      if (this.canSelectUser &&this.middleUserList &&this.middleUserList.length > 0) {
        this.middleUserList.forEach((user) => {
          let index = this.rightUserList.findIndex(
            (item) => item.id == user.id
          );
          if (index == -1) {
            candidateUserList.push(user);
          }
        });
      }


      if (this.maxSelectedItem > 0) {
        if (this.rightUserList.length + this.rightDepartList.length + this.rightGroupList.length + candidateUserList.length + candidateDepartList.length > this.maxSelectedItem) {
          this.$message.warning('选择超过数量限制');
          return;
        }
      }

      candidateDepartList.forEach(depart => {
        this.rightDepartList.push(depart);
      });

      candidateUserList.forEach(user => {
        this.rightUserList.push(user);
      })

    },
    removeAllRight() {
      // 取消右边所有的已选
      this.rightDepartList = [];
      this.rightUserList = [];
      this.rightGroupList = [];
    },
    removeRightUser(user) {
      // 取消右边选定的人
      let index = this.rightUserList.findIndex((ele) => ele.id == user.id);
      if (index >= 0) {
        this.rightUserList.splice(index, 1);
      }
    },
    removeRightDepart(depart) {
      // 取消右边选定的部门
      let index = this.rightDepartList.findIndex((ele) => ele.id == depart.id);
      if (index >= 0) {
        this.rightDepartList.splice(index, 1);
      }
    },
    removeRightGroup(group) {
      let index = this.rightGroupList.findIndex((ele) => ele.id == group.id);
      if (index >= 0) {
        this.rightGroupList.splice(index, 1);
      }
    },
    treeNodeClick(data, node) {
      // 左侧部门的树节点点击了，要先判断点击的是组织还是部门，才能去获取组织下的部门还是获取该部门的子部门和下属人员，在中间栏显示
      this.currentDepartId = data.id;
      if (data.isRootOrg) {
        let reqParam = {
          pid: 0,
          orgId: sessionStorage.getItem("orgId"),
        };
        getDeptListService(reqParam)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.middleDepartList = res.data || [];
              this.middleUserList = [];
            } else if (res.code == Constants.Code_Err) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$message.error(Constants.Err_Msg);
            }
          })
          .catch((error) => {
            this.$message.error(Constants.Err_Msg);
          });
      } else {
        getSubUserService({ deptId: data.id })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.middleDepartList = (res.data || {}).deptList || [];
            this.middleUserList = (res.data || {}).userList || [];
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error(Constants.Err_Msg);
        });
      }
    },
    //----------dialog 生命函数处理---------------
    beforeCloseHandler(done) {
      console.log("dialog before close");
      done();
      this.$emit("close", { dataKey: this.dataKey});
    },
    closeHandler() {
      console.log("dialog close   Handler");
    },
    closedHandler() {
      console.log("dialog closed    Handler");
    },
    submitSelectedList() {
      // 点击确定，选出合适的候选人，发出去
      // 再做一遍去重。这里其实没必要了，因为前面每次选择时都做了去重操作
      let data = {
        dataKey: this.dataKey,
      };
      let count = 0;
      if (this.canSelectDepart) {
        let departSet = new Set(this.rightDepartList);
        let departList = Array.from(departSet);
        data.departList = departList;
        count += departList.length;
      }
      if (this.canSelectUser) {
        let userSet = new Set(this.rightUserList);
        let userList = Array.from(userSet);
        data.userList = userList;
        count += userList.length;
      }
      if(this.canSelectGroup) {
        let groupSet = new Set(this.rightGroupList);
        let groupList = Array.from(groupSet);
        data.groupList = groupList;
        count += groupList.length;
      }
      if (count == 0) {
        this.$alert("当前未选择用户", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.rightUserList = [];
      this.rightDepartList = [];
      this.rightGroupList = [];
      this.$emit("close", data);
    },
    closeDialog() {
      // 点击“取消”关掉窗口
      this.$emit("close",{ dataKey: this.dataKey,flag:true});
    },
  },
};
</script>

<style lang="scss" scoped>
.choose_c {
  display: flex;
  width: 100%;
  justify-content: space-between;
  border: 1px solid #cdcdcd;
}

.wrapper {
  flex: 1;
  width: 33.33%;
}

.title_c {
  font-size: 20px;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #cdcdcd;
  user-select: none;
}

.wrapper + .wrapper {
  border-left: 1px solid #cdcdcd;
}

.head_c {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #cdcdcd;

  .el-checkbox {
    margin-left: 5px;
  }

  .el-button {
    margin-left: 5px;
  }
}

.tab {
  width: 50%;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
  user-select: none;
  padding-left: 5px;
}

.tab-active {
  color: #079dbd;
}

.tab + .tab {
  border-left: 1px solid #cdcdcd;
}

.tab-disabled {
  color: #ebeef5;
  cursor: not-allowed;
}

.body_c {
  height: 400px;
  overflow: auto;
}

.result_c,
.candidate_c {
  .el-tree-node__content {
    padding-left: 6px;
  }
}

.result_c .el-tree-node__content i {
  margin-right: 6px;
}

.group_c {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;

  ul {
    display: block;
    flex: 1;
  }

  .group-item {
    display: block !important;

    .el-tree-node__content {
      padding-left: 6px;
      display: flex;
      justify-content: space-between;
    }

    .is-selected {
      background-color: #f5f7fa !important;
    }
  }
}

/deep/.el-button.is-disabled {
  color: #C0C4CC !important;
}
</style>